import { useEffect, useState } from "react";

export const useSyncedState = <T>(syncedValue: T) => {
    const [value, setValue] = useState<T>(syncedValue);

    useEffect(() => {
        setValue(syncedValue);
    }, [syncedValue]);

    return [value, setValue] as const;
};
